import { render, staticRenderFns } from "./LaunchpackNoticeList.vue?vue&type=template&id=2f1e9fd2&scoped=true"
import script from "./LaunchpackNoticeList.vue?vue&type=script&lang=js"
export * from "./LaunchpackNoticeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1e9fd2",
  null
  
)

export default component.exports